import React, {Component} from "react";

import * as config from "../../../../constants/config";

export default class ProgressPanel extends Component {
    getLoadingProgress = () => {
        return ((this.props.loading / config.INITIALIZATION_NUMBER) * 100).toFixed(0);
    };

    render() {
        return (
            <div className="loading-info" style={{WebkitAppRegion: "no-drag"}}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{width: this.getLoadingProgress() + "%"}}
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                />
            </div>
        );
    }
}
